// @flow

import type { ChecklistState, ChecklistAction } from 'stores/flow-type/dashboard/checklist.type';

import {
  GET_CHECKLIST_REQUEST,
  GET_CHECKLIST_SUCCESS,
  GET_CHECKLIST_FAILURE,
  SELECT_CHECKLIST_REQUEST,
  SELECT_CHECKLIST_SUCCESS,
  SELECT_CHECKLIST_FAILURE,
  SKIP_ACTION_ON_CHECKLIST_REQUEST,
  SKIP_ACTION_ON_CHECKLIST_SUCCESS,
  SKIP_ACTION_ON_CHECKLIST_FAILURE,
  TRACK_EVENT_REQUEST,
  TRACK_EVENT_SUCCESS,
  TRACK_EVENT_FAILURE
} from 'stores/flow-type/dashboard/checklist.type';

const initialState: ChecklistState = {
  loading: false,
  success: false,
  selectChecklistLoading: false,
  selectChecklistSuccess: false,
  skipActionLoading: false,
  skipActionSuccess: false,
  trackEventLoading: false,
  trackEventSuccess: false,
  error: undefined,
  total: 0,
  style: 1,
  completed: 0,
  actions: []
};

const ChecklistReducers = (state: ChecklistState = initialState, action: ChecklistAction) => {
  switch (action.type) {
    case GET_CHECKLIST_REQUEST:
      return { ...state, loading: true, success: false };
    case GET_CHECKLIST_SUCCESS: {
      const { data } = action.payload;
      const { total, style, completed, actions, name } = data;

      return {
        ...state,
        loading: false,
        success: true,
        error: undefined,
        total,
        style,
        completed,
        actions,
        name
      };
    }
    case GET_CHECKLIST_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload
      };
    case SELECT_CHECKLIST_REQUEST:
      return { ...state, selectChecklistLoading: true, selectChecklistSuccess: false };
    case SELECT_CHECKLIST_SUCCESS: {
      const { data } = action.payload;
      const { total, style, completed, actions, name } = data;

      return {
        ...state,
        selectChecklistLoading: false,
        selectChecklistSuccess: true,
        error: undefined,
        total,
        style,
        completed,
        actions,
        name
      };
    }
    case SELECT_CHECKLIST_FAILURE:
      return {
        ...state,
        selectChecklistLoading: false,
        selectChecklistSuccess: false,
        error: action.payload
      };
    case SKIP_ACTION_ON_CHECKLIST_REQUEST:
      return { ...state, skipActionLoading: true, skipActionSuccess: false };
    case SKIP_ACTION_ON_CHECKLIST_SUCCESS: {
      return {
        ...state,
        skipActionLoading: false,
        skipActionSuccess: true,
        error: undefined
      };
    }
    case SKIP_ACTION_ON_CHECKLIST_FAILURE:
      return {
        ...state,
        skipActionLoading: false,
        skipActionSuccess: false,
        error: action.payload
      };
    case TRACK_EVENT_REQUEST:
      return { ...state, trackEventLoading: true, trackEventSuccess: false };
    case TRACK_EVENT_SUCCESS: {
      return {
        ...state,
        trackEventLoading: false,
        trackEventSuccess: true,
        error: undefined
      };
    }
    case TRACK_EVENT_FAILURE:
      return {
        ...state,
        trackEventLoading: false,
        trackEventSuccess: false,
        error: action.payload
      };
    default:
      return state;
  }
};

export default ChecklistReducers;
